import { Component, Input } from '@angular/core';

@Component({
    selector: 'ng-box',
    templateUrl: 'box.component.html'
})

export class BoxComponent{

    @Input() public boxIcon:string;
    @Input() public boxTitle:string;
    @Input() public showBoxFooter:boolean;

    constructor() { 
        this.boxIcon=''
        this.boxTitle=''
        this.showBoxFooter=false
    }

}